import { BaseService } from "./BaseService";

export const SecaoService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('secao/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos seções:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('secao', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de seção:', error);
            return false;
        }
    },
    async select(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIGet('secao/select', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas seções:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`secao/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de seção:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`secao/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de seção:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('secao/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir seção(s):', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('secao/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar seção(s):', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('secao/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar seção(s):', error);
            return false;
        }
    }, 
}